export default __webpack_public_path__ + "static/media/img_about-abg-m.d440d1bb.jpg";